export function showDuplicateModal(message) {
  const overlay = document.createElement("div");
  overlay.style.cssText = [
    "position:fixed", "inset:0", "z-index:99999",
    "display:flex", "align-items:center", "justify-content:center",
    "background:rgba(0,0,0,0.5)",
  ].join(";");

  overlay.innerHTML = `
    <style>
      @keyframes slideUp { from { transform:translateY(16px);opacity:0 } to { transform:translateY(0);opacity:1 } }
      #dup-modal-box { animation: slideUp 0.25s ease; }
    </style>
    <div id="dup-modal-box" style="
      background:#fff;
      border-radius:16px;
      padding:36px 28px 28px;
      max-width:320px;
      width:calc(100% - 48px);
      text-align:center;
      box-shadow:0 8px 32px rgba(0,0,0,0.18);
    ">
      <div style="
        width:52px;height:52px;
        border-radius:50%;
        background:#FFF3CD;
        display:flex;align-items:center;justify-content:center;
        margin:0 auto 16px;
        font-size:24px;
      ">⚠️</div>
      <p style="
        font-size:16px;
        font-weight:600;
        color:#222;
        margin:0 0 24px;
        line-height:1.5;
      ">${message}</p>
      <button id="dup-modal-close" style="
        width:100%;
        padding:13px 0;
        border:none;
        border-radius:10px;
        background:#222;
        color:#fff;
        font-size:15px;
        font-weight:600;
        cursor:pointer;
      ">확인</button>
    </div>
  `;

  document.body.appendChild(overlay);

  const close = () => overlay.remove();
  document.getElementById("dup-modal-close").addEventListener("click", close);
  overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
}
